export default __webpack_public_path__ + "static/media/logo.fa523c65.png";